import { render, staticRenderFns } from "./ReportTabsTemplate.vue?vue&type=template&id=604a3600"
import script from "./ReportTabsTemplate.vue?vue&type=script&lang=js"
export * from "./ReportTabsTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports